module.exports = __webpack_public_path__ + "img/20220219_072202.5cc43eb0.jpg";